import { LayoutStateProvider } from "@etframework/ui.components";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Suspense } from "react";
import { I18nextProvider } from "react-i18next";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { IconLoading } from "./components/Loading/IconLoading";
import appTranslationInstance from "./config/i18n";
import { routes } from "./routing/routes";
import RolePermissionsComponent from "./store/components/RolePermissionsComponent";
import { useElmahIo } from "./utils/elmah";
import { useUserGuiding } from "./utils/userGuiding";

const router = createBrowserRouter(routes);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      //staleTime: 5 * 60 * 1_000,         // Data is considered fresh for 5 minutes
      //cacheTime: 30 * 60 * 1_000,          // Cached data remains available for 30 minutes
      refetchOnWindowFocus: false
    }
  }
});

function App() {
  //Initialize hooks
  useElmahIo();
  useUserGuiding();

  return (
    <Suspense fallback={<IconLoading />}>
      <I18nextProvider i18n={appTranslationInstance}>
        <QueryClientProvider client={queryClient}>
          <RolePermissionsComponent />
          <LayoutStateProvider>
            <RouterProvider router={router} fallbackElement={<IconLoading />} />
          </LayoutStateProvider>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </I18nextProvider>
    </Suspense>
  );
}

export default App;
